import { useEffect, useState } from "react";
import { api } from "../../lib/api";

let _missingCache = null;
let _missingPromise = null;
const _missingSubscribers = new Set();

export function fetchMissingSummary() {
  if (_missingCache) return Promise.resolve(_missingCache);
  if (_missingPromise) return _missingPromise;
  _missingPromise = api.get("/admin/missing-data-summary").then((r) => {
    _missingCache = r.data || {};
    _missingPromise = null;
    _missingSubscribers.forEach((cb) => cb(_missingCache));
    return _missingCache;
  }).catch(() => {
    _missingPromise = null;
    _missingCache = {};
    return _missingCache;
  });
  return _missingPromise;
}

export function useMissingSummary() {
  const [data, setData] = useState(_missingCache || null);
  useEffect(() => {
    let live = true;
    fetchMissingSummary().then((d) => { if (live) setData(d); });
    const cb = (d) => { if (live) setData(d); };
    _missingSubscribers.add(cb);
    return () => { live = false; _missingSubscribers.delete(cb); };
  }, []);
  return data;
}
